/* eslint-disable no-unused-vars */
export enum OrderType {
  PICKUP = "PICKUP",
  DELIVERY = "DELIVERY",
  CURBSIDE = "CURBSIDE",
  DINE_IN = "DINE_IN",
}
export const orderTypes = Object.values(OrderType);

export type CategoryType = "REGULAR" | "SERVICE";
export enum CardOptionType {
  NONE = "NONE",
  SAVED_CARD = "SAVED_CARD",
  DIFFERENT_CARD = "DIFFERENT_CARD",
}
export type GiftCardSource = { token: string; last4: string; balance: number };
export enum Tag {
  MERCHANT_DETAILS = "MERCHANT_DETAILS",
  MENU = "MENU",
  ITEMS = "ITEMS",
  ITEM_DETAILS = "ITEM_DETAILS",
  CATEGORIES = "CATEGORIES",
  MERCHANT_POLICIES = "MERCHANT_POLICIES",
  MERCHANT_PREFERENCES = "MERCHANT_PREFERENCES",
  RETAIL_PICKUP_TIME = "RETAIL_PICKUP_TIME",
  CATEGORY_ITEMS = "CATEGORY_ITEMS",
  UNCATEGORY_ITEMS = "UNCATEGORY_ITEMS",
  MERCHANT_PAYMENT_CONFIG = "MERCHANT_PAYMENT_CONFIG",
  CUSTOMER_DETAILS = "CUSTOMER_DETAILS",
  ANY = "*",
}
export enum PipType {
  MERCHANT_INFO = "Merchant Info",
  MERCHANT_TYPE = "Merchant Type",
}
